
import { BrandColors } from '../theme';

export const datepickerTokens = {
    date: {
        rangeSelectedBackground: BrandColors.primary[500],
        rangeSelectedColor: BrandColors.surface[0]
    }
}